import React, { useState } from 'react';
import ActionSheet from '../../Common/ActionSheet';
import { StyledDiv, StyledSpan } from '../../../Theme/CommonStyled';
import {
  StyledAddressContainer,
  StyledPhoneContainer,
  StyledSloganContainer
} from './style';
import Icon from '../../Common/Icon';
import OpenTime from '../../Home/OpenTime';
import Title from '../../Common/Title';
import { useTranslation } from 'react-i18next';
import { ClubLinkBranchInfoType } from '../../../Types/landing.type';
import Button from '../../Common/Button';
import { useNavigate } from 'react-router';
import NavigationModal from '../../Common/NavigationModal';
import useCreditsStore from '../../../Store/Credits';
import { StyledPhoneNumber } from 'src/Components/ContactUs/style';

type BranchActionSheetType = {
  branchData: ClubLinkBranchInfoType;
  open: boolean;
  onDismiss: (value: boolean) => void;
  id?: string;
  hasCreditButton?: boolean;
};
const BranchActionSheet: React.FC<BranchActionSheetType> = ({
  branchData,
  open,
  onDismiss,
  id = 'branch',
  hasCreditButton = false
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const setDataLength = useCreditsStore((state) => state.setDataLength);

  const { contactUsViewModel } = branchData || {};
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <NavigationModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        branchData={contactUsViewModel}
      />
      <ActionSheet
        open={open}
        onDismiss={() => onDismiss(false)}
        footer={false}
        id={id}>
        <StyledDiv display="flex" flexDirection="column">
          {hasCreditButton && branchData?.branchName && (
            <StyledDiv
              display="flex"
              direction="rtl"
              mb={9}
              alignItems="center">
              <Icon name="store" fontSize={18} color="normalText" ml={5} />
              <StyledSpan fontSize={4} color="normalText">
                {branchData.branchName}
              </StyledSpan>
            </StyledDiv>
          )}
          {contactUsViewModel?.branchPhone && (
            <StyledPhoneContainer>
              <StyledPhoneNumber
                href={`tel:${contactUsViewModel?.branchPhone}`}>
                {contactUsViewModel?.branchPhone}
              </StyledPhoneNumber>
              <StyledDiv>
                <StyledSpan fontSize={4} color="normalText">
                  {t('global.phone')}
                </StyledSpan>
                <Icon
                  name="phone_1"
                  fontSize={14}
                  color="secondaryText"
                  ml={7}
                />
              </StyledDiv>
            </StyledPhoneContainer>
          )}
          {contactUsViewModel?.address && (
            <StyledAddressContainer>
              <StyledDiv
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                mb={7}
                width="100%">
                <StyledDiv textAlign="right" fontSize={2} color="normalText">
                  {contactUsViewModel?.address}
                </StyledDiv>
                <Icon
                  name="location-outline"
                  color="secondaryText"
                  fontSize={14}
                  ml={7}
                />
              </StyledDiv>
              {(contactUsViewModel?.GoogleLink ||
                contactUsViewModel?.WazeLink) && (
                <StyledSpan
                  fontSize={4}
                  color="primaryBlue"
                  cursor="pointer"
                  onClick={() => {
                    navigate(-1);
                    setOpenModal(true);
                  }}>
                  {t('branches.navigation')}
                </StyledSpan>
              )}
            </StyledAddressContainer>
          )}
          {!!contactUsViewModel?.openTimes?.length && (
            <OpenTime
              openTimes={contactUsViewModel?.openTimes}
              titleMargin={1}
              bg="secondaryBackground"
            />
          )}
          {contactUsViewModel?.slogan && (
            <>
              <Title title={t('landing.slogan')} mt={8} mb={6} />
              <StyledSloganContainer>
                {contactUsViewModel?.slogan}
              </StyledSloganContainer>
            </>
          )}
          {hasCreditButton && (
            <Button
              onClick={() => {
                setDataLength(10);
                navigate(`/credits?branchId=${branchData.clubBranchId}`);
                onDismiss(false);
              }}
              mt={8}
              icon={<Icon name="credit" fontSize={14} color="normalText" />}>
              {t('landing.creditsAndGifts')}
            </Button>
          )}
        </StyledDiv>
      </ActionSheet>
    </>
  );
};

export default BranchActionSheet;
